import {
  ADD_ACCOUNT_SUCCESS,
  ADD_ACCOUNT_FAIL,
  GET_ACCOUNT_SUCCESS,
  GET_ACCOUNT_FAIL,
  GET_ACCOUNTS_SUCCESS,
  GET_ACCOUNTS_FAIL,
  UPDATE_ACCOUNT_SUCCESS,
  UPDATE_ACCOUNT_FAIL,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAIL,
  SET_ACCOUNT_LOADING,
  CLEAR_ACCOUNT_ERROR,
  GET_VALIDATORS_SUCCESS,
  GET_VALIDATORS_FAIL,
} from './types';

const initialState = {
  loading: false,
  account: null,
  accounts: [],
  error: null,
  validators: [],
};

const accountReducer = function (state = initialState, action) {
  switch (action.type) {
    // this is for fetching loading time setter
    case SET_ACCOUNT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CLEAR_ACCOUNT_ERROR:
      return {
        ...state,
        error: null,
        updated: false,
        account: null,
      };

    case ADD_ACCOUNT_SUCCESS:
      return {
        ...state,
        account: action.payload,
        loading: false,
      };

    case GET_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accounts: action.payload,
        loading: false,
      };

    case GET_ACCOUNT_SUCCESS:
      return {
        ...state,
        account: action.payload,
        loading: false,
        error: null,
      };

    case GET_VALIDATORS_SUCCESS:
      return {
        ...state,
        validators: action.payload,
        loading: false,
        error: null,
      };
    case UPDATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        account: action.payload,
        loading: false,
        updated: true,
        accounts: state.accounts.map((account) => {
          if (account._id === action.payload._id) {
            return action.payload;
          } else {
            return account;
          }
        }),
      };

    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        accounts: state.accounts.filter(
          (account) => account._id !== action.payload
        ),
        loading: false,
      };

    case GET_ACCOUNTS_FAIL:
    case GET_ACCOUNT_FAIL:
    case UPDATE_ACCOUNT_FAIL:
    case ADD_ACCOUNT_FAIL:
    case DELETE_ACCOUNT_FAIL:
    case GET_VALIDATORS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default accountReducer;
